import { Box, useTheme } from "@mui/material";
import React from "react";

import { ChatMessage as ChatMessageType } from "../../types";
import { ChatMessage } from "./ChatMessage";
import { getMessageKey } from "./utils";

interface ChatMessageListProps {
  messages: ChatMessageType[];
}

const ChatMessageListComponent: React.FC<ChatMessageListProps> = ({ messages }) => {
  const theme = useTheme();
  const { chatTheme } = theme;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: chatTheme.spacing.messageGap }}>
      {messages.map((m, idx) => (
        <ChatMessage key={getMessageKey(m, idx)} message={m} />
      ))}
    </Box>
  );
};

export const ChatMessageList = React.memo(ChatMessageListComponent);
